import React from 'react';

export const SketchHubIcon = ({ className = 'w-6 h-6', ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* A small 'hub' star over a sketch pad */}
    <path d="M7 3h7l3 3v15a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
    <path d="M14 3v4h4" />
    <path d="M8 12h8" opacity="0.6" />
    <path d="M8 15h6" opacity="0.6" />
    <path d="M17.5 9.2l.7 1.6 1.7.2-1.3 1.1.4 1.7-1.5-.9-1.5.9.4-1.7-1.3-1.1 1.7-.2.7-1.6z" fill="currentColor" stroke="none" opacity="0.25" />
  </svg>
);
